<template>
    <v-container>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" v-bind="{ loading }">
                    <v-card-title>
                        <span> 참여코드 입력 </span>
                    </v-card-title>
                    <v-card-subtitle class="font-size-14 grey--text text--lighten-2">
                        <span> 전달받은 참여코드를 입력해주세요 </span>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-form>
                            <v-text-field
                                v-model="code"
                                ref="code-input"
                                v-bind="{
                                    ...attrs_input,
                                    errorMessages,
                                    hideDetails: 'auto',
                                    placeholder: '참여코드',
                                }"
                                @input="onCodeInput"
                                @keydown.enter="enter"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn block color="primary" v-bind="{ disabled, loading }" @click="enter">
                            <v-icon dense class="mr-2">mdi-login-variant</v-icon>
                            <span> 참여하기 </span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { attrs_input } from "@/assets/variables";
import api from "@/api";

export default {
    props: {
        withCreate: { type: Boolean, default: false },
    },
    data: () => ({
        code: null,
        errorMessages: null,

        loading: false,

        attrs_input,
    }),
    computed: {
        disabled() {
            return (this.code?.length || 0) < 8;
        },
    },
    methods: {
        async enter() {
            if (this.loading) return;
            else this.loading = true;
            try {
                await api.v1.interview.get({ code: this.code });
                this.$router.push(`/interview/${this.code}`);
            } catch (error) {
                this.errorMessages = error.response.data.message;
                this.$refs["code-input"].focus();
            } finally {
                this.loading = false;
            }
        },

        onCodeInput() {
            this.code = this.code?.toUpperCase?.();
        },
    },
};
</script>

<style>
</style>